import React from "react";
import "./Confirm_Location_modal.css";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Back_arrow_holder from "../../Back_arrow_holder/Back_arrow_holder";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import Black_Btn from "../../common_btn/black_btn/Black_Btn";


function Confirm_Location_modal(props) {
  const navigate = useNavigate();

  const handleOrangeButtonClick = () => {
    props.onHide(); // Close the modal
    navigate("/add-new-address"); // Redirect to /add-new-address
  };

  return (
    <>
      <section className="Confirm_Location_modal modal-holder">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Confirm_Location_modal modal-holder"
        >
          <Modal.Header>
            <Back_arrow_holder onClick={() => props.onBackaction()} />
            <Modal.Title>Confirm Location</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="map-holder">
              <div
                style={{
                  maxWidth: "100%",
                  overflow: "hidden",
                  color: "red",
                  width: "100%",
                  height: "100%",
                  aspectRatio: 1 / 0.7,
                }}
              >
                <div
                  id="g-mapdisplay"
                  style={{ height: "100%", width: "100%", maxWidth: "100%" }}
                >
                  <iframe
                    style={{ height: "100%", width: "100%", border: 0 }}
                    frameBorder="0"
                    src="https://www.google.com/maps/embed/v1/place?q=bavdhan&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                  ></iframe>
                </div>
              </div>
            </div>
          </Modal.Body>
          <div className="footer-btn-holder">

                <p className="town_text">Kothrud</p>
                <p className="full_address">Shivkrupa Colony, Alkapuri Society, Kothrud, Pune, Maharashtra, 411038</p>

            {/* <div className="text-center btn_holder">
              <Button
                className="orange-outline-btn"
                type="submit"
                onClick={handleOrangeButtonClick}
              >
                {props?.orange_btn_text}
              </Button>
            </div> */}

            <div className="text-center btn_holder">
              <Black_Btn btnText={props?.green_btn_text}  onClick={() => props.onHide()}/>
            </div>

            {/* <div
              className="text-center btn_holder"
              onClick={() => {
                props.onOpenSelectCountry();
              }}
            >
              <Button className="submit-btn" type="submit">
                {props?.green_btn_text}
              </Button>
            </div> */}
          </div>
        </Modal>
      </section>
    </>
  );
}

export default Confirm_Location_modal;
